import { useEffect, useState } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import { Link } from "react-router-dom";
import DeleteUser from "./DeleteUser";

const Users = () => {
    const { auth } = useAuth();
    const [users, setUsers] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [userID, setUserID] = useState(null)

    useEffect(() => {
        const fetch = async () => {
            try {
                const response = await axiosPrivate.get("/users", {headers: {Authorization: "Bearer " + auth.accessToken}});
                setUsers(response.data);
            } catch(err) {
                console.log(err);
            }
        }
        fetch();
    }, [auth.accessToken, axiosPrivate]);

    const deleteUsr = (evt) => {
        setUserID(evt.target.id)
    }

    return (
        <div>
            {userID && <DeleteUser userID={userID} setUserID={setUserID} setUsers={setUsers} />}
            <div style={{paddingBottom:'2rem'}}>
                <span className="relative flex justify-center">
                    <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-transparent bg-gradient-to-r from-transparent via-gray-500 to-transparent opacity-75"></div>
                    <span className="relative z-10 bg-white px-6">Users</span>
                </span>
            </div>
            <div>
                <Link to="/add-user">
                    <strong className="rounded border border-indigo-500 bg-indigo-500 px-3 py-1.5 text-[13px] font-medium text-white">
                        Add User
                    </strong>
                </Link>

                <div className="overflow-x-auto" style={{paddingTop:'1.5rem'}}>
                    <table className="min-w-full divide-y-2 divide-gray-200 bg-white text-sm">
                        <thead className="ltr:text-left rtl:text-right">
                            <tr>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Email</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Disabled</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Action</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-200">
                            {users.map(user => (
                                <tr className="odd:bg-gray-50" key={user.id}>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{user.email}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{`${user.disabled}`}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700 flex gap-x-1.5">                                    
                                        <Link to={`/edit-user/${user.id}`}>Edit</Link>
                                        <button onClick={deleteUsr} id={user.id} type="button">
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default Users;